import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { NfcLandingPageTitle } from '../NfcLandingPageTitle/NfcLandingPageTitle'

import { NfcLandingPageFaqAccordion } from './NfcLandingPageFaqAccordion'

export const NfcLandingPageFaq: FC = () => {
  return (
    <div
      className="m-auto max-w-5xl bg-light-primary-low px-4 py-10"
      itemScope
      itemType="https://schema.org/FAQPage"
    >
      <div>
        <NfcLandingPageTitle className="px-10 tablet:text-center">
          <FormattedMessage id="nfc.faq.title" />
        </NfcLandingPageTitle>
      </div>

      <div className="mt-4 w-full flex-1 tablet:mt-6">
        <NfcLandingPageFaqAccordion />
      </div>
    </div>
  )
}
